import displayNotification from './displayNotification';
import displayError from './displayError';

export const getShareableLink = (path) => {
  const link = `${window.location.protocol}//${window.location.host}/${path}`;
  navigator.clipboard.writeText(link).then(() => {
    displayNotification({ message: 'Link copied.', title: 'Success' });
  }).catch(() => {
    displayError({
      message: 'Failed to copy link to clipboard. Please try again.',
      title: 'Copy Error',
    });
  });
};

export default getShareableLink;
